<template>
  <div class="container flex-1">
    <div
      style="
        width: calc(100% - 432px);
        background: #ffffff;
        border-radius: 0 16px 16px 16px;
        height: 100%;
        margin-right: 16px;
      "
      class="flex-column flex-1"
    >
      <div v-if="!eduitApp" class="flex-column flex-1" style="overflow-y: auto">
        <jd-title label="积分竞拍列表装修"></jd-title>
        <div style="display: flex; margin-top: 20px">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
          >
            <qrcode-vue
              v-if="qrcodeVue.value"
              class="qrcode"
              :id="'qrcode'"
              :ref="'qrcode'"
              :size="qrcodeVue.size"
              :value="qrcodeVue.value"
              :bgColor="qrcodeVue.bgColor"
              :fgColor="qrcodeVue.fgColor"
              style="text-align: center"
            >
            </qrcode-vue>
            <div style="color: #999999; font-size: 14px; margin-top: 8px">
              京东APP扫码查看
            </div>
          </div>
          <div style="margin: 26px 0 0 30px">
            <div
              style="
                font-weight: bold;
                font-size: 16px;
                color: #1f1f1f;
                display: flex;
                align-items: center;
              "
            >
              <img
                src="https://cdn-image.yucrm.cn/1f66a21766464bbe91baacc6826e52e3.png"
                style="width: 24px; height: 24px; margin-right: 8px"
              />
              页面设置完成~
            </div>
            <div
              style="
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                margin: 12px 0;
                padding-left: 32px;
              "
            >
              您还可以通过以下方式完成推广
            </div>
            <div
              style="
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                padding-left: 32px;
              "
            >
              更多小程序挂载能力<span
                @click="openUrl()"
                style="color: #2768ff; cursor: pointer"
                >点击查看>></span
              >
            </div>
            <jd-button
              label="下载二维码"
              style="margin-top: 30px; padding-left: 32px"
              @click="handleSrcImg()"
            ></jd-button>
          </div>
        </div>
        <div style="display: flex; margin: 30px 0 10px 0">
          推广链接：
          <el-tooltip
            class="item"
            effect="dark"
            :content="qrcodeVue.value"
            placement="top-start"
          >
            <div
              style="
                max-width: 400px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                line-height: 16px;
              "
            >
              {{ qrcodeVue.value }}
            </div>
          </el-tooltip>
          <!-- <div v-else></div> -->
          <span
            v-clipboard:copy="qrcodeVue.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            style="color: #2768ff; cursor: pointer; margin: 0 8px"
            >复制</span
          >
        </div>
        <div
          style="color: #f7911c; font-size: 12px; margin: 10px 0 0 0"
          v-if="!qrcodeVue.value"
        >
          官方要求，活动链接及二维码需小程序通过试运营期后方可使用，当前不可用。
        </div>
        <div class="mt16">
          <jd-button
            label="编辑"
            type="blue"
            @click="eduitApp = true"
          ></jd-button>
          <jd-button
            label="去添加积分竞拍活动"
            @click="goToExchange"
          ></jd-button>
        </div>
      </div>

      <div v-else class="flex-column flex-1" style="overflow-y: auto">
        <div class="titleBody">
          <div class="titleText">
            <div class="titleicon"></div>
            <span class="titlecontent">积分竞拍列表装修</span>
          </div>
        </div>
        <el-form class="frombody" label-width="auto">
          <el-form-item label="活动背景图：">
            <div class="fromitem">
              <el-upload
                style="display: flex; align-items: center"
                action="/jd-hd-web/image/upload"
                ref="backgroundImage"
                :on-change="
                  (file, fileList) => {
                    imageLabelsChange(file, 'backgroundImage');
                  }
                "
                :show-file-list="false"
                :limit="100"
                accept=".png, .jpg, .jpeg"
                :auto-upload="false"
              >
                <jd-button type="blue">自定义上传</jd-button>
              </el-upload>
              <jd-button
                style="margin: 0 16px"
                type="blueText"
                @click="
                  formConfig.backgroundImage = CacheformConfig.backgroundImage
                "
                >重置</jd-button
              >
              <div slot="reference" class="size-style">
                尺寸建议：750*1624px；支持格式：jpg，png
              </div>
            </div>
          </el-form-item>
          <el-form-item label="tab栏设置：">
            <div class="little-body">
              <el-form-item label="选中字体颜色：">
                <el-color-picker
                  v-model="formConfig.tabSelectedTextColor"
                ></el-color-picker>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.tabSelectedTextColor =
                      CacheformConfig.tabSelectedTextColor
                  "
                  >重置</jd-button
                >
              </el-form-item>
              <el-form-item label="选中背景颜色：">
                <el-color-picker
                  v-model="formConfig.tabSelectedBgColor"
                ></el-color-picker>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.tabSelectedBgColor =
                      CacheformConfig.tabSelectedBgColor
                  "
                  >重置</jd-button
                >
              </el-form-item>
              <el-form-item label="未选中字体颜色：">
                <el-color-picker
                  v-model="formConfig.tabTextColor"
                ></el-color-picker>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.tabTextColor = CacheformConfig.tabTextColor
                  "
                  >重置</jd-button
                >
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="奖品区背景设置：">
            <div class="little-body">
              <el-form-item label="背景渐变颜色(上)：">
                <el-color-picker
                  v-model="formConfig.prizeBgColorTop"
                ></el-color-picker>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.prizeBgColorTop = CacheformConfig.prizeBgColorTop
                  "
                  >重置</jd-button
                >
              </el-form-item>
              <el-form-item label="背景渐变颜色(下)：">
                <el-color-picker
                  v-model="formConfig.prizeBgColorBottom"
                ></el-color-picker>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.prizeBgColorBottom =
                      CacheformConfig.prizeBgColorBottom
                  "
                  >重置</jd-button
                >
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="状态印章设置：">
            <div class="little-body">
              <el-form-item label="成交印章：">
                <el-upload
                  style="display: flex; align-items: center"
                  action="/jd-hd-web/image/upload"
                  ref="dealSealImage"
                  :on-change="
                    (file, fileList) => {
                      imageLabelsChange(file, 'dealSealImage');
                    }
                  "
                  :show-file-list="false"
                  :limit="100"
                  accept=".png, .jpg, .jpeg"
                  :auto-upload="false"
                >
                  <jd-button type="blue">自定义上传</jd-button>
                </el-upload>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.dealSealImage = CacheformConfig.dealSealImage
                  "
                  >重置</jd-button
                >
                <div class="size-style">尺寸建议：130*130px</div>
              </el-form-item>
              <el-form-item label="流拍印章：">
                <el-upload
                  style="display: flex; align-items: center"
                  action="/jd-hd-web/image/upload"
                  ref="unDealSealImage"
                  :on-change="
                    (file, fileList) => {
                      imageLabelsChange(file, 'unDealSealImage');
                    }
                  "
                  :show-file-list="false"
                  :limit="100"
                  accept=".png, .jpg, .jpeg"
                  :auto-upload="false"
                >
                  <jd-button type="blue">自定义上传</jd-button>
                </el-upload>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.unDealSealImage = CacheformConfig.unDealSealImage
                  "
                  >重置</jd-button
                >
                <div class="size-style">尺寸建议：130*130px</div>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="按钮样式设置：">
            <div class="little-body">
              <el-form-item label="按钮字体色：">
                <div style="display: flex; align-items: center">
                  <el-color-picker
                    v-model="formConfig.buttonTextColor"
                  ></el-color-picker>
                  <jd-button
                    style="margin: 0 16px"
                    type="blueText"
                    @click="
                      formConfig.buttonTextColor =
                        CacheformConfig.buttonTextColor
                    "
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="按钮背景图：">
                <div style="display: flex; align-items: center">
                  <el-upload
                    style="display: flex; align-items: center"
                    action="/jd-hd-web/image/upload"
                    ref="buttonBgImage"
                    :on-change="
                      (file, fileList) => {
                        imageLabelsChange(file, 'buttonBgImage');
                      }
                    "
                    :show-file-list="false"
                    :limit="100"
                    accept=".png, .jpg, .jpeg"
                    :auto-upload="false"
                  >
                    <jd-button type="blue">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    style="margin: 0 16px"
                    type="blueText"
                    @click="
                      formConfig.buttonBgImage = CacheformConfig.buttonBgImage
                    "
                    >重置</jd-button
                  >
                  <div class="size-style">尺寸建议：442*78px</div>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="赚积分任务入口：">
            <div class="point-task-show">
              <el-radio-group
                v-model="formConfig.earnTaskIsShow"
                style="margin: 10px 0"
              >
                <el-radio :label="false">不显示</el-radio>
                <el-radio :label="true"
                  >显示（C端兑换列表页开启赚积分任务列表入口）</el-radio
                >
              </el-radio-group>
              <div
                class="point-task-img-box"
                v-show="formConfig.earnTaskIsShow"
              >
                <el-upload
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 6px;
                    width: 44px;
                    height: 50px;
                  "
                  action="/jd-hd-web/image/upload"
                  ref="earnTaskImageUrl"
                  :on-change="
                    (file, fileList) => {
                      imageLabelsChange(file, 'earnTaskImageUrl');
                    }
                  "
                  :show-file-list="false"
                  :limit="100"
                  accept=".png, .jpg, .jpeg"
                  :auto-upload="false"
                >
                  <img
                    class="point-task-img"
                    :src="formConfig.earnTaskImageUrl"
                  />
                </el-upload>
                <jd-button
                  style="margin: 0 16px"
                  type="blueText"
                  @click="
                    formConfig.earnTaskImageUrl =
                      'https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointTask/earn_task_img2.png'
                  "
                  >重置</jd-button
                >
                <div
                  slot="reference"
                  class="size-style"
                  style="font-size: 14px"
                >
                  尺寸建议：128*148px
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="小程序店铺信息：">
            <div>
              <el-radio-group v-model="formConfig.shopNameType">
                  <el-radio :label="0">统一显示配置店铺</el-radio>
                  <el-radio :label="2">不显示店铺信息</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-form>

        <div>
          <jd-button
            label="保存设置，并获取推广链接"
            type="blue"
            @click="savePointApp"
          ></jd-button>
          <jd-button
            label="重置"
            @click="formConfig = JSON.parse(JSON.stringify(CacheformConfig))"
          ></jd-button>
          <jd-button
            label="去添加积分竞拍活动"
            @click="goToExchange"
          ></jd-button>
        </div>
      </div>
    </div>

    <div
      style="width: 416px; background: #ffffff; height: 100%; overflow-y: auto"
    >
      <jd-title label="页面效果预览"></jd-title>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 20px;
          position: relative;
        "
      >
        <phoneShow
          :formConfig="formConfig"
          :list="pointExchangeActList"
        ></phoneShow>
        <div
          v-if="formConfig.earnTaskIsShow"
          style="
            position: absolute;
            right: 8px;
            top: 410px;
            height: 80px;
            width: 70px;
          "
        >
          <img
            :src="formConfig.earnTaskImageUrl"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcodeVue from "qrcode-vue";
import {
  PublicUpload,
  getDecorationInfoDetail,
  saveDecoration,
  pointAuctionPage,
} from "@/api/jhk/pointAuction.js";
import phoneShow from "./phoneShow.vue";
import { mapState } from "vuex";

const baseUrl = "https://cdn-image.yucrm.cn/images/dy/pointAuction/";

export default {
  components: {
    qrcodeVue,
    phoneShow,
  },
  created() {
        this.buriedPoint(1, "积分竞拍", "互动管理", "互动活动");
    this.queryTemplate();
  },
  data() {
    return {
      defaultIndex: 0,
      pageUrl: "",
      // 限制图片上传格式
      extensions: [".jpg", ".png"],
      pointExchangeActList: [],
      eduitApp: true,
      recordData: {
        // 分页
        current: 1,
        size: 100,
      },
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "", //二维码地址
        logo: this.$globalCdn + "/thdImg/common/jd_logo.svg", //logo图片
      },
      CacheformConfig: {
        backgroundImage: baseUrl + "auction_list_bg.png",
        tabSelectedTextColor: "#222222",
        tabSelectedBgColor: "#FFDD77",
        tabTextColor: "rgba(34,34,34,0.6)",
        prizeBgColorTop: "#F8CF5F",
        prizeBgColorBottom: "#F2F2F4",
        dealSealImage: baseUrl + "auction_success_icon.png",
        unDealSealImage: baseUrl + "auction_fail_icon.png",
        buttonTextColor: "#FFFFFF",
        buttonBgImage: baseUrl + "auction_btn_bg.png",
        moreActivityIsShow: false,
        earnTaskIsShow: false, //赚积分任务入口
        earnTaskImageUrl:
          "https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointTask/earn_task_img2.png",
          shopNameType: 0,
      },
      formConfig: {
        backgroundImage: baseUrl + "auction_list_bg.png",
        tabSelectedTextColor: "#222222",
        tabSelectedBgColor: "#FFDD77",
        tabTextColor: "rgba(34,34,34,0.6)",
        prizeBgColorTop: "#F8CF5F",
        prizeBgColorBottom: "#F2F2F4",
        dealSealImage: baseUrl + "auction_success_icon.png",
        unDealSealImage: baseUrl + "auction_fail_icon.png",
        buttonTextColor: "#FFFFFF",
        buttonBgImage: baseUrl + "auction_btn_bg.png",
        moreActivityIsShow: false,
        earnTaskIsShow: false, //赚积分任务入口
        earnTaskImageUrl:
          "https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointTask/earn_task_img2.png",
          shopNameType: 0,
      },
      pageform: {
        templateScene: "6",
        current: 1,
        size: 10,
      },
      templateId: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    async savePointApp() {
      let keyArr = [
        "backgroundImage",
        "tabSelectedTextColor",
        "tabSelectedBgColor",
        "tabTextColor",
        "prizeBgColorTop",
        "prizeBgColorBottom",
        "dealSealImage",
        "unDealSealImage",
        "buttonTextColor",
        "buttonBgImage",
      ];
      for (let i = 0; i < keyArr.length; i++) {
        let key = keyArr[i];
        if (!this.formConfig[key]) {
          this.$message.warning("请先完善页面信息~");
          return;
        }
      }
      let formData = {
        detailInfo: JSON.stringify(this.formConfig),
        templateName: "积分竞拍列表模板",
        type: "5",
      };
      if (this.templateId) {
        formData.id = this.templateId;
      }
      let res = await saveDecoration(formData);
      if (res.code == 1) {
        this.queryTemplate();
        this.$message.success("保存成功");
      } else {
        this.$message.error(res.message);
      }
    },
    async queryTemplate() {
      let res = await getDecorationInfoDetail(5);
      if (res.code == 1) {
        if (res.data) {
          let xcxUrl = this.$commonUrl(); // 正式
          let params1 = `venderId%3D${this.$store.getters.loginUserInfo.venderId}`;
          this.qrcodeVue.value =
            xcxUrl +
            "pages_2/pointAuctionList/pointAuctionList.html%3f" +
            params1;
          this.eduitApp = false;
          this.formConfig = JSON.parse(res.data.detailInfo);
          this.$set(this.formConfig, "shopNameType",this.formConfig.shopNameType || 0);
        } else {
          this.qrcodeVue.value = "";
          this.templateId = "";
          this.formConfig = JSON.parse(JSON.stringify(this.CacheformConfig));
          this.eduitApp = true;
        }
        // let params = {
        //   size: 100,
        //   current: 1,
        //   prizeQryFlag: 1,
        //   activityType: 57,
        //   showFlag: true,
        // };
        // let result = await pointAuctionPage(params);
        // if (result.code == 200) {
        //   this.pointExchangeActList = result.data.records;
        // }
      }
    },
    imageLabelsChange(file, field) {
      console.log(file);
      if (file.status == "success" && file.response) {
        if (file.response.code == 1) {
          this.formConfig[field] = file.response.data;
          this.$message.success("上传成功");
        } else {
          this.$message.error(file.response.message || "图片上传失败");
        }
        return;
      }
      // 图片格式校验
      let fileExtensions = this.extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext),
      );
      if (!fileExtensions) {
        this.$message.error("图片格式错误");
        this.$refs[field].clearFiles();
        return;
      } else {
        this.$refs[field].submit();
      }
      // 图片上传尺寸限制
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   const img = new Image();
      //   img.onload = () => {
      //     if (img.width != 750 || img.height != 1624) {
      //       this.$message.error("图片尺寸错误");
      //       this.$refs[field].clearFiles();
      //       return;
      //     }
      //     // 尺寸校验通过后执行上传
      //     this.$refs[field].submit();
      //   };
      //   img.src = e.target.result;
      // };
      // reader.readAsDataURL(file.raw);
    },
    goToExchange() {
      this.$emit("changeTab");
    },
    openUrl() {
      this.$router.push(
        "/interactiveMarketing/promotionActivity/suspensionDiagram",
      );
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "imgQR";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-form .el-form-item__content {
  display: flex;
}
.point-task-show {
  display: flex;
  flex-direction: column;
  line-height: 32px;

  .point-task-img-box {
    padding: 8px 16px;
    width: 406px;
    background: #f7f8fa;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .point-task-img {
    width: 44px;
    height: 50px;
  }
}
.container {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;

  .frombody {
    padding: 20px 10px 10px 10px;
    background: #fff;
    .size-style {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      white-space: nowrap;
    }
    .little-body {
      background: #f7f8fa;
      padding: 16px;
      width: 445px;
    }
    .fromitem {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
  }

  .titleBody {
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .titleText {
      display: flex;
      align-items: center;

      .titleicon {
        width: 2px;
        background: #2768ff;
        margin-right: 8px;
        height: 12px;
      }

      .titlecontent {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #1f1f1f;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}
</style>
